var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "fc-day-breakdown" }, [
    _c(
      "ul",
      _vm._l(_vm.events, function (event, index) {
        return _c("calendar-day-breakdown-event", {
          key: index,
          attrs: { event: event },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }